<template>
	<div v-if="problemDetail" class="alert-message">
		<strong>
			{{ problemDetail.status }} {{ problemDetail.title }}
		</strong><br />
		<span>{{ problemDetail.detail }}</span>
		<div v-if="fieldErrors.length > 0">
			De volgende velden bevatten fouten:
			<ul>
				<li v-for="error in fieldErrors" :key="error.key">
					{{ error.key }}: {{ error.value }}
				</li>
			</ul>
		</div>
		<slot></slot>
	</div>
</template>

<script lang="ts" setup>
	import type {PropType} from 'vue';
	import {computed, watch} from 'vue';
	import type {ProblemDetail} from '~/lib/types/fetchErrors';
	import {useConfirm} from '~/composables/useConfirm';

	const props = defineProps({
		problemDetail: {
			type: Object as PropType<ProblemDetail>,
			default: undefined
		}
	});

	const fieldErrors = computed(() => {
		if (!props.problemDetail || !props.problemDetail.fieldErrors) {
			return [];
		}

		return Object.entries(props.problemDetail.fieldErrors).map(([key, value]) => {
			return {
				key,
				value
			};
		});
	});

	const status = computed(() => props.problemDetail?.status);

	watch(status, (newStatus) => {
		if (String(newStatus) !== '401') {
			return;
		}
		useConfirm(
			'Sessie verlopen of niet ingelogd.\r\n ' +
			'\r\n ' +
			'Wil je de pagina verversen om opnieuw in te loggen en verder te gaan?',
			async () => {
				document.location.reload();
			}, () => {
				/* Do nothing on cancel */
			}
		);
	});
</script>

<style scoped>
	.alert-message {
		border-left: 4px solid currentColor;
		color: #ff0000;
		background-color: #ffe5e5;
		padding: .5em 1em;
		margin-bottom: 15px;
		white-space: pre-line;
	}
</style>
